import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  &.nextPlanIsFree {
    border-color: ${({ theme }) => theme.palette.warning[600]};
  }
`;
